import React, { useEffect, useState, useRef } from "react";
import useWindowResize from "../../hooks/useWindowResize";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";
import Location from "../../public/assets/icons/location.svg";
import styles from "./AccordionItem.module.scss";

const AccordionItem = ({ skey, title, text, fullscreen = false, links, parentId }) => {
  const ref = useRef();
  const queryParams = useRef(null);
  
  const [readmore, setReadMore] = useState(skey == 'car');
  const isBelowMedium = useWindowResize(768);

  const handleClick = () => {
    setReadMore(!readmore);
  };
  const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(() => {
    if (!fullscreen) {
      if (isBelowMedium) {
        setReadMore(false);
      } else {
        setReadMore(skey != 'car');
      }
    }
    if (window.location && window.location.search) {
      queryParams.current = window.location.search.replace('?q=', '');
    }
    if(isBelowMedium && queryParams.current) {
      if(queryParams.current == parentId && isBelowMedium) {
        setReadMore(true);
      }
    }
  }, [isBelowMedium]);

  return (
    <div className={styles.AccordionItem} ref={ref}>
      <div
        className={styles.titleContent}
        style={{
          borderBottom:
            fullscreen || isBelowMedium ? null : "1px solid #A9A9A9",
        }}
      >
        <div className={styles.title}>{title}</div>
        <button
          className={styles.accordionButton}
          onClick={handleClick}
          style={{ display: !fullscreen && !isBelowMedium ? "none" : "block" }}
        >
          <div className={readmore ? styles.hideLineFirst : null}></div>
          <div className={readmore ? styles.hideLine : null}></div>
        </button>
        <div
          className={styles.linksContainer}
          style={{ display: links && !isBelowMedium ? "flex" : "none" }}
        >
          {skey == 'car' && <a onClick={handleClick}>Directions</a>}
          {links &&
            links.length > 0 &&
            links.map((l) =>
              l?.type === "button" ? (
                <ButtonWithIcon link={l} outline={false} key={l.type} />
              ) : (
                <a
                  key={l?.title}
                  href={l?.url}
                  target={l?.target}
                  style={{ cursor: "pointer" }}
                >
                  
                  {l?.title}
                </a>
              )
            )}
        </div>
      </div>
      <div
        className={`${styles.content} ${
          readmore ? null : styles.contentClosed
        }`}
      >
        <div
          className={styles.linksContainer}
          style={{ display: links && isBelowMedium ? "flex" : "none" }}
        >
          {links &&
            links.length > 0 &&
            links.map((l) =>
              l?.type !== "button" ? (
                <a
                  key={l?.title}
                  href={l?.url}
                  target={l?.target}
                  style={{ cursor: "pointer" }}
                >
                  {l?.title}
                </a>
              ) : (
                <ButtonWithIcon link={l} outline={false} key={l.type} />
              )
            )}
        </div>
        {fullscreen ? (
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className={styles.innerContent}
          ></div>
        ) : (
          text.map((d) => (
            <div key={d.title}>
              {d.title && (
                <div
                  dangerouslySetInnerHTML={{ __html: d.title }}
                  className={styles.contentTitle}
                ></div>
              )}
              {d.text && (
                <div dangerouslySetInnerHTML={{ __html: d.text }}></div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AccordionItem;
